// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__mBsSx","content":"styles_content__HECkW","title":"styles_title__UwoCX","description":"styles_description__s1T0k","tagList":"styles_tagList__5J6T9"};